module.exports = __webpack_public_path__ + "img/pTaiwan.946ffc88.png";